const dr = [-1, -1, -1, 0, 0, 0, 1, 1, 1];
const dc = [-1, 0, 1, -1, 0, 1, -1, 0, 1];

const drNeighbor = [-1, 0, 1, 1, 1, 0, -1, -1];
const dcNeighbor = [-1, -1, -1, 0, 1, 1, 1, 0];

export { dr, dc, drNeighbor, dcNeighbor };
